import React, { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';

export default function PaymentFailed() {
    const { slug } = useParams();
    const [searchParams] = useSearchParams();
    const [copied, setCopied] = useState(false);

    // Extract Transaction ID from slug, query parameters, or URL pathname
    const trxId =
        slug ||
        searchParams.get("txnid") ||
        searchParams.get("trx_id") ||
        searchParams.get("transactionId") ||
        searchParams.get("transaction_id") ||
        searchParams.get("mihpayid") ||
        window.location.pathname.split('/').filter(Boolean).pop() ||
        "N/A";

    const handleCopy = () => {
        if (trxId && trxId !== "N/A") {
            navigator.clipboard.writeText(trxId);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {/* Failure Icon */}
                <div style={styles.iconContainer}>
                    <div style={styles.iconRipple} />
                    <CancelIcon style={styles.icon} />
                </div>

                <h2 style={styles.heading}>Payment Failed</h2>

                {/* Transaction ID Box */}
                <div style={styles.trxBox}>
                    <span style={styles.trxLabel}>Transaction ID</span>
                    <div style={styles.trxValueWrapper}>
                        <code style={styles.trxValue}>{trxId}</code>
                        <button
                            onClick={handleCopy}
                            style={styles.copyBtn}
                            title="Copy Transaction ID"
                        >
                            {copied ? (
                                <DoneIcon style={{ fontSize: 18, color: '#EF4444' }} />
                            ) : (
                                <ContentCopyIcon style={{ fontSize: 18, color: '#9CA3AF' }} />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
        padding: '20px',
        boxSizing: 'border-box',
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
    },
    card: {
        width: '100%',
        maxWidth: '420px',
        backgroundColor: 'rgba(30, 41, 59, 0.7)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '24px',
        padding: '40px 32px',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    },
    iconContainer: {
        position: 'relative',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '24px',
    },
    iconRipple: {
        position: 'absolute',
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: 'rgba(239, 68, 68, 0.15)',
        filter: 'blur(8px)',
    },
    icon: {
        fontSize: '72px',
        color: '#EF4444',
        position: 'relative',
        zIndex: 1,
    },
    heading: {
        margin: '0 0 28px 0',
        fontSize: '24px',
        fontWeight: '700',
        color: '#FFFFFF',
        letterSpacing: '-0.02em',
    },
    trxBox: {
        backgroundColor: 'rgba(15, 23, 42, 0.6)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '16px',
        padding: '16px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
    },
    trxLabel: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#94A3B8',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
    },
    trxValueWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        maxWidth: '100%',
    },
    trxValue: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#F87171',
        fontFamily: "'Fira Code', 'Courier New', monospace",
        wordBreak: 'break-all',
    },
    copyBtn: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '6px',
        transition: 'background-color 0.2s',
    },
};

